export const iconFontAwesomeMediaplaybackForward = (
	<i className="fa-solid fa-forward"></i>
);
